export default __webpack_public_path__ + "images/kn_1244da.svg";